var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1C8.7614 1 11 3.23857 11 6C11 8.7614 8.7614 11 6 11C3.23857 11 1 8.7614 1 6H2C2 8.20915 3.79086 10 6 10C8.20915 10 10 8.20915 10 6C10 3.79086 8.20915 2 6 2C4.76807 2 3.66622 2.55691 2.93246 3.43271L4 4.5H1V1.5L2.22328 2.72324C3.14001 1.66754 4.49205 1 6 1ZM6.5 3.5L6.4999 5.7925L8.1213 7.4142L7.4142 8.1213L5.4999 6.2065L5.5 3.5H6.5Z",
    fill: "#C18A00"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/due.b0d33f1f.svg";
export { ForwardRef as ReactComponent };